import { Database } from 'types/supabase'
import { supabaseClient } from 'supabase'
import { CountedRows } from 'supabase/importRuns/queryImportRuns'

export type ImportBeatRow = Database['public']['Tables']['import_beats']['Row']

/**
 * The columns the Beats page reads: every column of import_beats (0027 + the
 * area pair from 0028).
 */
export const IMPORT_BEAT_COLUMNS =
  'handle, page_url, active, notes, area_city_id, area_municipality, created_at, updated_at'

/**
 * PostgREST caps every list response at 1000 rows without saying so. The read
 * asks for at most that many plus the server's exact count, so a cut list is
 * detectable (total > rows.length, or a null total) instead of silently short.
 */
const MAX_ROWS = 1000

/**
 * Every import beat, active ones first, then by handle. Gated by the RLS
 * policy "Admins read import beats" (0027): a non-admin reads nothing.
 *
 * An error is thrown, never swallowed into `[]`: an empty list would read as
 * "no beats", which is a different (and wrong) statement.
 */
export const listImportBeats = async (): Promise<CountedRows<ImportBeatRow>> => {
  const { data, error, count } = await supabaseClient
    .from('import_beats')
    .select(IMPORT_BEAT_COLUMNS, { count: 'exact' })
    .order('active', { ascending: false })
    .order('handle')
    .limit(MAX_ROWS)

  if (error) {
    throw error
  }
  return { rows: (data ?? []) as ImportBeatRow[], total: count ?? null }
}
